<div *ngIf="(_actualItinerary !== undefined) || this.userService.itineraryActive.length > 0" class="nav p-0 m-0 col-12 align-items-center mt-0">
    <div class="flex-xg-row flex-lg-row flex-md-column flex-sm-column m-0 p-0 font-dark justify-content-between align-items-center card" id="band">
      <usb-flight-modal
                          class="align-items-center d-flex flex-row w-100"
                          *ngIf="_actualItinerary"
                          [invoke]="1"
                          [_actualItinerary]="_actualItinerary"
                          [payloadSearch]="payloadSearch"
                          [formTransports]="formTransports"
                          [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                          [component]="'results'"
                          [openModalFly]="openModalFly"
                          (updateFly)="updateFly($event)"
      >
    </usb-flight-modal>

    </div>
</div>
